// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3wwjo","dragIcon":"Choice_dragIcon__2K4Qw","left":"Choice_left__2mKO9","input":"Choice_input__1eD-a"};